module.exports = __webpack_public_path__ + "static/media/manabi_banner_en.efdd4db5.png";